import React, { Component } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FormControl, Select, MenuItem } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import "chart.js/auto";

export const options = {
  responsive: true,
  plugins: {
    title: {
      display: true,
      text: 'Chart.js Bar Chart',
    },
  },
  options: {
    layout: {
      padding: 20,
    },
  },
  maintainAspectRatio: false,
};

class YearlyBreakdownPopup extends Component {
  state = {
    repaymentPlans: [],
    selectedRepaymentPlans: [],
    loanType: '',
    data: {},
    select: [],
    allRepaymentPlan: [],
  };

  handleLoanTypeChange = (event) => {
    let selected;
    if (event.target.value === 'All') {
      selected = this.state.allRepaymentPlan;
    } else {
      const repaymentPlans = this.state.repaymentPlans.find(
        (item) => item.loanId === event.target.value
      );
      selected = repaymentPlans.value;
    }
    const labels = selected.map((repayment) => repayment.year);
    const data = {
      labels: labels,
      datasets: [
        {
          label: event.target.value.toUpperCase(),
          data: selected.map((repayment) => repayment.monthly),
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          fill: false,
        },
      ],
    };

    this.setState({
      loanType: event.target.value === 'All' ? 'All' : event.target.value,
      selectedRepaymentPlans: selected,
      labels: labels,
      data: data,
    });
  };

  componentDidMount() {
    const repaymentPlans = this.props.recommendedPaymentPlan;
    const select = repaymentPlans.map((item) => {
      return {
        loanName: item.loanName,
        loanId: item.loanId,
      };
    });

    const years = repaymentPlans[0].value.map(item => {
      return { year: item.year, data: [] }
    })
    years.map(loan => {
      for (let key of repaymentPlans) {
        for (let loanItem of key.value) {
          if (loan.year === loanItem.year) {
            loan.data.push(loanItem)
          }
        }
      }
    })

    const reducedArray = years.map(loan => {
      return loan.data.reduce((acc, curr) => {
        return {
          year: loan.year,
          monthly: acc.monthly + curr.monthly,
          subsidy: acc.subsidy + curr.subsidy,
          interest: acc.interest + curr.interest,
          balance: acc.balance + curr.balance,
        }
      }, { monthly: 0, subsidy: 0, interest: 0, balance: 0 })
    })


    const labels = reducedArray.map((repayment) => repayment.year);
    const data = {
      labels: labels,
      datasets: [
        {
          label: 'All',
          data: reducedArray.map((repayment) => repayment.monthly),
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          fill: false,
        },
      ],
    };
    this.setState({
      repaymentPlans: repaymentPlans,
      selectedRepaymentPlans: reducedArray,
      loanType: 'All',
      labels: labels,
      data: data,
      select,
      allRepaymentPlan: reducedArray,
    });
  }
  //
  render() {
    return (
      <div>
        <Dialog
          maxWidth='xl'
          open={true}
          scroll='paper'
          onClose={() => this.props.close()}
          fullWidth
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: '30px',
              marginBottom: '30px',
            }}
          >
            <DialogTitle>Yearly Breakdown</DialogTitle>

            <FormControl variant='filled' style={{ minWidth: 200 }}>
              <Select
                labelId='loanType'
                name='loanType'
                displayEmpty
                label='Select'
                value={this.state.loanType}
                onChange={this.handleLoanTypeChange}
                className='form-control'
              >
                <MenuItem value='All'>All</MenuItem>
                {this.state.select.map((item) => (
                  <MenuItem value={item.loanId}>{item.loanName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <DialogContent>
            <div
              style={{
                height: '390px',
                margin: '0 auto 30px auto',
                width: '80%',
              }}
            >
              <Bar options={options} data={this.state.data} />
            </div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Year</TableCell>
                  <TableCell>MMP</TableCell>
                  <TableCell>Subsidy</TableCell>
                  <TableCell>Balance</TableCell>
                  <TableCell>Interest</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.yearlyDialog &&
                  this.state.selectedRepaymentPlans.length > 0 &&
                  this.state.selectedRepaymentPlans.map((repayment) => (
                    <TableRow key={repayment.year}>
                      <TableCell>{repayment.year}</TableCell>
                      <TableCell>
                        {parseFloat(repayment.monthly).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {parseFloat(repayment.subsidy).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {parseFloat(repayment.balance).toFixed(2)}
                      </TableCell>
                      <TableCell>
                        {parseFloat(repayment.interest).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default YearlyBreakdownPopup;
